<template>
  <div>
    <el-container>
      <el-main style="margin: 1px">
        <el-row style="height:100px"></el-row>
        <el-row>
          <el-col :span="12" :offset="6">
            <el-form
              :model="uploadFileForm"
              ref="uploadFileForm"
              label-position="left"
            >
              <el-form-item
                prop="customer_file"
                required="required"
              >
                <el-upload
                  drag
                  action="fakeaction"
                  :auto-upload="false"
                  :show-file-list="true"
                  :multiple="false"
                  :limit="1"
                  :file-list="fileList"
                  :on-change="onSuccess"
                  style="width: 100%"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    {{ $t("message.uploadTips3") }}<br />
                      {{ $t("message.uploadTips4") }} {{ maxSize / 1024 / 1024}} MB
                  </div>
                </el-upload>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="1" :offset="9">
            <el-button type="primary" size="small" @click="uploadFile()">{{
              $t("button.upload")
            }}</el-button>
          </el-col>
          <el-col :span="1" :offset="1">
            <el-button type="success" size="small" @click="resetForm('uploadFileForm')">{{
              $t("button.reset")
            }}</el-button>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import i18n from "../../i18n";
export default {
  data() {
    return {
      fileList: [],
      uploadFileForm: {
        customer_file: "",
      },
      allowedExtensions: ['xls', 'xlsx'],
      // 设置最大文件大小（例如：20MB）
      maxSize: window.INS_CONFIG.FileSize * 1024 * 1024,
    };
  },
  methods: {
    onSuccess(file, fileList) {
      // 检查文件大小
      console.log(file.size);
      if (file.size > this.maxSize) {
        this.$notify.error(i18n.t("message.sizeOver") + " " + window.INS_CONFIG.FileSize + "MB");
        this.fileList = [];
        return false;
      }
      // 检查文件类型
      console.log(file.name.split(".").length)
      if (!this.allowedExtensions.includes(file.name.split(".")[file.name.split(".").length-1])) {
        this.$notify.error(i18n.t("message.notSupportFile"));
        this.fileList = [];
        return false;
      }
      
      this.uploadFileForm.customer_file = file.raw;
      this.$notify({
        type: "success",
        message: file.name,
      });
    },
    uploadFile() {
      this.$refs["uploadFileForm"].validate((valid) => {
        if (valid) {
          let formDate = new FormData();
          formDate.append("file", this.uploadFileForm.customer_file);
          return new Promise((resolve, reject) => {
            this.$httpList
              .addMultiGoods(localStorage.getItem(localStorage.getItem("integration-username")),formDate)
              .then((res) => {
                if (res.code == "1001") {
                  this.$notify({
                    type: "success",
                    message: i18n.t("message.success"),
                  });
                } else {
                  this.$notify({
                    type: "error",
                    message: i18n.t("message.error"),
                  });
                }
                this.resetForm("uploadFileForm");
                this.fileList = [];
                resolve(res);
              })
              .catch((err) => {
                this.$notify({
                  type: "error",
                  message: i18n.t("message.error"),
                });
                reject(err);
              });
          });
        } else {
          this.$notify({
            type: "error",
            message: "Please complete the form",
          });
          setTimeout(() => {
            const formRef = this.$refs["uploadFileForm"];
            // 清空所有表单项的验证结果
            formRef.clearValidate();
          }, 1000);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style>
 .el-upload {
  width: 90%;
  height: 250px;
}
 .el-upload .el-upload-dragger {
  width: 90%;
  height: 250px;
}
</style>